import { Col } from "antd";
import styled from "styled-components";
import colors from "constants/colors";
import { FOOTER_BREAKPOINT } from "../constants";

export const ContactLink = styled.a`
  color: white;

  &:hover {
    color: ${colors.secondary};
  }
`;

export const SocialIconLink = styled.a`
  display: inline-block;
  color: lightgrey;

  font-size: 3.2em;

  padding-left: 4%;

  transition: transform 0.2s ease, color 0.2s ease;

  &:hover {
    color: ${colors.secondary};
    transform: translateY(-2px);
  }

  @media (max-width: ${FOOTER_BREAKPOINT - 1}px) {
    &:first-child {
      padding-left: 0;
    }
  }
`;

export const SocialLinksCol = styled(Col)`
  @media (max-width: ${FOOTER_BREAKPOINT - 1}px) {
    margin-top: 1.5rem;
    margin-bottom: 1rem;
  }
`;
